import ActionsForm from '@/shared/mixins/actionsForm'
import FilterGroupPaste from '@/views/private/realestate/components/FilterGroupPaste.vue'
import FilterFolder from '../filterfolder/filterfolder.vue'
import CommissionRepository from '@/shared/http/repositories/realestate/commission'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import RequestsRepository from '@/shared/http/repositories/realestate/requestRepository'
import { loading } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  mixins: [ActionsForm, ExpenseMixin],
  props: ['flFilterFolder'],
  components: {FilterGroupPaste, FilterFolder, AutocompleteZ},
  name: 'formSales',
  data () {
    return {
      title: 'Buscar Venda',
      consultaenterprise: [],
      consultacomissao: [],
      consultapagamento: [],
      selectedComissao: {},
      SearchItems: {
        corretorid: '',
        clienteId: '',
        empreendimentoId: '',
        formaPagament: '',
        DataInicio: '',
        DataFinal: '',
        corretor: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      }
    }
  },
  mounted () {
    this.GetAllEnterprise()
    this.onLoad()
    this.GetAllOptions()
    this.GetAllRealtors()
  },
  methods: {
    GetAllOptions () {
      loading.push()
      CommissionRepository.GetFormOfPayment()
        .then(Response => {
          loading.pop()
          this.consultapagamento = Response.data
        })
        .catch(Error => {
          loading.pop()
        })
    },
    GetAllEnterprise () {
      loading.push()
      RequestsRepository.GetAllEnterprises()
        .then(Response => {
          loading.pop()
          this.consultaenterprise = Response.data.data
        })
        .catch(Error => {
          loading.pop()
        })
    },
    GetAllRealtors () {
      loading.push()
      CommissionRepository.GetCorretorByName()
        .then(Response => {
          loading.pop()
          this.corretor = Response.data
        })
        .catch(Error => {
          loading.pop()
        })
    },
    onLoad () {
      loading.push()
      CommissionRepository.GetAll()
        .then(Response => {
          loading.pop()
          this.consultacomissao = Response.data.data
        })
        .catch(Error => {
          loading.pop()
        })
    },
    updateTable (id) {
      this.$emit('updateTable', id)
    },
    SearchItemss (id) {
      this.$emit('updateCorretor', id)
    },
    Clear () {
      localStoreHelper.imobiliaria.consultaVendas(null)
      this.$refs.CommissionTypeahead.clear()
      Object.keys(this.SearchItems).forEach(prop => {
        if (prop === 'corretor') {
          this.SearchItems[prop].value = ''
        } else {
          this.SearchItems[prop] = ''
        }
      })
      this.SearchItems.corretorId = ''
      this.$emit('SearchItems', this.SearchItems, false)
    },
    Search () {
      this.SearchItems.corretorId = this.SearchItems.corretor.value
      this.$emit('SearchItems', this.SearchItems, true)
      localStoreHelper.imobiliaria.consultaVendas(this.SearchItems)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesinquiry/components/formSales/formSales.js